// extracted by mini-css-extract-plugin
export default {"input_section":"textinput_input_section__yuS7b"};